
class HiAngelPart {
  constructor(parentCont, id, data) {
    this.parentCont = parentCont;
    this.id = id;
    this.partData = data;

    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.sprite = new PIXI.Sprite.fromFrame(this.id);
    this.parentCont.addChild(this.sprite);

    // init frame
    this.setFrame(0);
  }

  // --------------------------------------------------------------
  // Set Frame
  // --------------------------------------------------------------

  setFrame(frameId) {
    if (this.partData[frameId][0] === 0) {
      // inactive/hidden
      this.sprite.visible = false;
    } else {
      // active
      this.sprite.visible = true;
      this.sprite.x = this.partData[frameId][1];
      this.sprite.y = this.partData[frameId][2];
    }
  }
}

export default HiAngelPart;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/HiAngelPart.js